import Vue from 'vue'
import TemplateBuy from './components/TemplateBuy.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueClipboard from 'vue-clipboard2'

Vue.use(VuetifyDialog, {
  context: {
    vuetify,
  },
  confirm: {
    actions: {
      false: '取消',
      true: {
        text: '确认',
      },
    },
    width: 400,
  },
})

axios.defaults.withCredentials = true

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? store.state.domain : '/api',
  timeout: 10000,
})

Vue.use(VueAxios, service)

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.config.productionTip = false

const el = document.createElement('div')
document.body.append(el)

new Vue({
  store,
  vuetify,
  render: (h) => h(TemplateBuy),
}).$mount(el)
